module.exports = __webpack_public_path__ + "static/media/天聲好手.9b3946d3.jpg";